import { Component, OnInit, Input, Inject, ViewEncapsulation } from '@angular/core';
import { ShelvableBackend } from '../../services/ShelvableBackend/ShelvableBackend'
import { Shelf } from '../../services/ShelvableBackend/Shelf'
import { StateService } from '@uirouter/angular';
import { NgbActiveModal } from '@mattlewis92/ng-bootstrap';
import swal from 'sweetalert';
import { Utilities } from '../../services/Utilities'

import { BehaviorSubject, Observable } from 'rxjs'

@Component({
    selector: 'user-library',
    templateUrl: './shelf-settings.html',
    styleUrls: ['./shelf-settings.css', './shelf-settings.mobile.css'],
    encapsulation: ViewEncapsulation.None
})
export class ShelfSettingsComponent implements OnInit {
    @Input() shelfName:string;
    @Input() username:string;

    shelf:Shelf;

    renamingShelf:boolean = false;
    
    newShelfName:BehaviorSubject<string> = new BehaviorSubject<string>(null);
    shelfNameValidity = this.newShelfName.flatMap((newName) => newName && newName != '' ? this.shelvableBackend.validateShelfName(newName, false) : Observable.of(null)).shareReplay(1);

    async ngOnInit() {
        var username = await this.shelvableBackend.loggedInUserObs.usernameObs.take(1).toPromise();
        
        if (!username || username !== this.stateService.params.username) {
            this.stateService.go('^');
            return;
        }
        
        this.newShelfName.next(this.shelfName);

        this.shelf = await this.shelvableBackend.getLoggedInUserShelf(this.shelfName);

        var exists = await this.shelf.exists.filter(Utilities.isNotNull).take(1).toPromise();
        if (!exists) {
            this.stateService.go('^');
        }
    }

    constructor(private shelvableBackend:ShelvableBackend, private stateService:StateService, public activeModal: NgbActiveModal) {}
    
    setShelfPrivacy(isPublic) {
        this.shelvableBackend.setShelfPrivacy(this.shelfName, isPublic);
    }
    
    async removeBookshelf() {
        var counts = await Promise.all([this.shelf.books.getLength(), this.shelf.end.getLength()]);
        var numberOfBooks = counts[0] + counts[1];
        swal({
            title: 'Are you sure you want to remove bookshelf "' + this.shelfName + '"?',
            text: 'There ' + (numberOfBooks === 1 ? 'is ' : 'are ') + (numberOfBooks === 0 ? 'no' : numberOfBooks) + ' book'+ (numberOfBooks === 1 ? '' : 's') + ' on it.\n This cannot be undone.',
            type: "warning",
            showCancelButton: true,
            confirmButtonClass: "btn-danger",
            confirmButtonText: "Yes, delete it.",
            cancelButtonText: "No, leave it.",
            closeOnConfirm: true,
            closeOnCancel: true
        }, (isConfirm) => {
            if (isConfirm) {
                this.shelvableBackend.deleteShelf(this.shelfName);
                
                if (this.stateService.current.parent === 'shelf') {
                    // redirect home if we're on this shelf's page
                    this.stateService.go('user', {user: this.username});
                } else {
                    this.activeModal.dismiss();
                }                
            }
        });
    };
    
    async renameShelf(newName) {
        //TODO: this takes a while
        this.renamingShelf = true;
        var oldName = this.shelfName;
        var onShelfPage = this.stateService.current.parent === 'shelf';
        try {
            await this.shelvableBackend.renameShelf(this.shelfName, newName);
            this.renamingShelf = false;
            this.stateService.go(this.stateService.current.name, {username: this.username, shelfName: newName});
        } catch (err) {
            this.renamingShelf = false;            
            swal("There was an error renaming your shelf.", "Sorry about that.", "error");
        }
    }

}


// WEBPACK FOOTER //
// ./web/static/components/shelf-settings/shelf-settings.ts